export type StringMapBase = {
  key: number;
  value: string;
};

export enum SortEnumType {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type DropdownOption = { label: string; value: string };

export const SemenTypeOptions: DropdownOption[] = [
  { label: 'Conv', value: 'Conv' },
  { label: 'RS F', value: 'RS F' },
  { label: 'RS M', value: 'RS M' },
  { label: 'SF M', value: 'SF M' },
  { label: 'SF F', value: 'SF F' },
];

export type Me = {
  userId: string;
  azureObjectId: string;
  email: string;
  displayName: string | null;
  givenName: string | null;
  surname: string | null;
  jobTitle: string | null;
  department: string | null;
  companyName: string | null;
  mobilePhone: string | null;
  preferredLanguage: string | null;
  accountEnabled: boolean;
  roles: Array<{
    roleId: string;
    companyId: string;
    name: string;
  }>;
  companies: Array<{
    companyId: string;
    code: string;
    name: string;
  }>;
  permissions: Array<{
    permissionId: string;
    code: string;
    name: string;
  }>;
} | null;

export type WeatherResponse = {
  currentConditions: {
    temp: number;
    conditions: string;
  };
};

export const sexedOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

export const verifiedOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

export const sexOptions = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
  { label: 'Unknown', value: 'Unknown' },
];

export const sexTypeOptions = [
  { label: 'Male (Yes)', value: 'Male' },
  { label: 'Female (Yes)', value: 'Female' },
  { label: 'Conventional (No)', value: 'Conventional' },
] as const;

export type SemenType = (typeof sexTypeOptions)[number]['value'];

export const cssCertifiedOptions = [
  { label: 'Yes', value: 100000001 },
  { label: 'No', value: 100000000 },
];
